import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    footerContainer: 'p-4 space-y-2',
    footerShippingTaxHint: 'body-4 my-1 c-grey-20',
    footerTotalAmount: 'body-1',
    footerTotalLabel: 'subtitle-4',
    savingsContainer: 'b-b b-grey-60 bg-grey-90 px-4 py-2 text-center',
    savingsDetails: 'body-3 c-grey-30',
    savingsHeading: 'body-3'
  }
} satisfies RecursivePartial<DialogConfig['miniCart']>
